/* ============================================================
   NEAT para Shopify — Carrito lateral (AJAX)
   ------------------------------------------------------------
   REGLA DE ENVÍO:
   - Solo 35 cápsulas: envío calculado en checkout.
   - Plus 105 cápsulas: envío calculado en checkout.
   - Max 175 cápsulas: envío gratis a todo Chile.
   - Si el carrito contiene AL MENOS UN MAX 175,
     todo el pedido califica para envío gratis.
   ============================================================ */

(function () {
  "use strict";

  var N = window.NEAT || {};
  var estado = { items: [], total: 0, count: 0 };

  /* ---------------- Formato de moneda ---------------- */

  function clp(centavos) {
    var valor = Math.round((centavos || 0) / 100);

    try {
      return "$" + valor.toLocaleString("es-CL");
    } catch (e) {
      return "$" + valor;
    }
  }

  /* ---------------- Detectar Pack MAX ---------------- */

  function esPackMax(item) {
    if (!item) return false;

    var variante = (item.variant_title || "").toLowerCase();

    return (
      variante.indexOf("175") !== -1 ||
      variante.indexOf("neat max") !== -1
    );
  }

  /*
   * Basta con que exista AL MENOS UN Pack MAX
   * para que el carrito completo tenga envío gratis.
   *
   * Ejemplos:
   *
   * SOLO = calculado
   * PLUS = calculado
   * SOLO + PLUS = calculado
   *
   * MAX = gratis
   * MAX + MAX = gratis
   * MAX + SOLO = gratis
   * MAX + PLUS = gratis
   * MAX + SOLO + PLUS = gratis
   */

  function carritoTieneEnvioGratis() {
    if (!estado.items.length) return false;

    return estado.items.some(function (item) {
      return esPackMax(item);
    });
  }

  /* ---------------- Llamadas al carrito ---------------- */

  function pedir(url, opciones) {
    return fetch(url, opciones).then(function (r) {
      if (!r.ok) {
        throw new Error("Error de carrito");
      }

      return r.json();
    });
  }

  function leer() {
    return pedir(
      N.routes.cart_url + ".js",
      {
        headers: {
          Accept: "application/json"
        }
      }
    );
  }

  function agregar(variantId, cantidad) {
    return pedir(
      N.routes.cart_add_url + ".js",
      {
        method: "POST",

        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },

        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: cantidad || 1
            }
          ]
        })
      }
    )
      .then(leer)
      .then(function (carro) {
        pintar(carro);
        abrir();
        latir();
      })
      .catch(function () {
        alert(
          "No pudimos agregar el producto. Intenta de nuevo."
        );
      });
  }

  function cambiar(linea, cantidad) {
    return pedir(
      N.routes.cart_change_url + ".js",
      {
        method: "POST",

        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },

        body: JSON.stringify({
          line: linea,
          quantity: cantidad
        })
      }
    ).then(pintar);
  }

  /* ---------------- Pintado ---------------- */

  function pintar(carro) {
    estado.items = carro.items || [];
    estado.total = carro.total_price || 0;
    estado.count = carro.item_count || 0;

    contador();

    var cont =
      document.getElementById("carrito-items");

    var pie =
      document.getElementById("carrito-pie");

    var prog =
      document.getElementById("carrito-progreso");

    if (!cont || !pie || !prog) {
      return;
    }

    /* ========================================================
       CARRITO VACÍO
       ======================================================== */

    if (!estado.items.length) {
      prog.innerHTML = "";

      cont.innerHTML =
        '<div class="carrito__vacio">' +
        "<p><strong>Tu carrito está vacío.</strong></p>" +
        "<p>Las cápsulas no van a llegar solas… todavía.</p>" +
        '<a class="btn btn--primario" href="' +
        N.routes.root_url +
        '">Ver productos</a>' +
        "</div>";

      pie.innerHTML = "";

      return;
    }

    /* ========================================================
       REGLA DE ENVÍO
       ======================================================== */

    var envioGratis =
      carritoTieneEnvioGratis();

    /*
     * Si existe al menos un MAX:
     * mostramos envío gratis.
     *
     * Si no existe MAX:
     * indicamos que el envío se calcula al finalizar.
     */

    if (envioGratis) {
      prog.innerHTML =
        '<p class="carrito__progreso-texto">' +
        '🎉 <strong>¡Envío gratis a todo Chile!</strong>' +
        "</p>" +

        '<div class="carrito__progreso-pista">' +
        '<div class="carrito__progreso-relleno" style="width:100%"></div>' +
        "</div>";
    } else {
      prog.innerHTML =
        '<p class="carrito__progreso-texto">' +
        "<strong>Envío calculado al finalizar la compra</strong>" +
        "</p>";
    }

    /* ========================================================
       PRODUCTOS
       ======================================================== */

    cont.innerHTML = estado.items
      .map(function (item, i) {

        var img = item.image
          ? item.image.replace(
              /(\.[a-z]+)(\?|$)/i,
              "_200x$1$2"
            )
          : N.imagenVacia;

        var detalle =
          item.variant_title &&
          item.variant_title !== "Default Title"
            ? item.variant_title
            : "";

        return (
          '<div class="item-carrito">' +

          '<div class="item-carrito__visual">' +
          '<img src="' +
          img +
          '" alt="" loading="lazy">' +
          "</div>" +

          "<div>" +

          '<div class="item-carrito__nombre">' +
          item.product_title +
          "</div>" +

          '<div class="item-carrito__detalle">' +
          detalle +
          "</div>" +

          '<div class="item-carrito__acciones">' +

          '<button type="button" ' +
          'data-linea="' +
          (i + 1) +
          '" data-delta="-1" ' +
          'aria-label="Quitar una unidad">−</button>' +

          '<span aria-live="polite">' +
          item.quantity +
          "</span>" +

          '<button type="button" ' +
          'data-linea="' +
          (i + 1) +
          '" data-delta="1" ' +
          'aria-label="Agregar una unidad">+</button>' +

          '<button type="button" ' +
          'class="item-carrito__eliminar" ' +
          'data-linea="' +
          (i + 1) +
          '" data-delta="0">Eliminar</button>' +

          "</div>" +
          "</div>" +

          '<div class="item-carrito__precio">' +
          clp(item.final_line_price) +
          "</div>" +

          "</div>"
        );
      })
      .join("");

    /* ========================================================
       BOTONES + / - / ELIMINAR
       ======================================================== */

    cont
      .querySelectorAll("[data-linea]")
      .forEach(function (b) {

        b.addEventListener(
          "click",
          function () {

            var linea =
              Number(b.dataset.linea);

            var delta =
              Number(b.dataset.delta);

            var actual =
              estado.items[linea - 1]
                ? estado.items[linea - 1].quantity
                : 0;

            var nueva =
              delta === 0
                ? 0
                : actual + delta;

            cambiar(
              linea,
              Math.max(0, nueva)
            );
          }
        );
      });

    /* ========================================================
       TOTALES
       ======================================================== */

    pie.innerHTML =
      '<div class="carrito__fila">' +
      "<span>Subtotal</span>" +
      "<span>" +
      clp(estado.total) +
      "</span>" +
      "</div>" +

      '<div class="carrito__fila">' +
      "<span>Envío</span>" +
      "<span>" +
      (
        envioGratis
          ? "Gratis a todo Chile"
          : "Se calcula en el pago"
      ) +
      "</span>" +
      "</div>" +

      '<div class="carrito__fila carrito__fila--total">' +
      "<span>Total</span>" +
      "<span>" +
      clp(estado.total) +
      "</span>" +
      "</div>" +

      '<a class="btn btn--cta btn--bloque" href="/checkout">' +
      "Ir a pagar" +
      "</a>" +

      '<a class="btn btn--fantasma btn--bloque" ' +
      'href="' +
      N.routes.cart_url +
      '" style="margin-top:.5rem">' +
      "Ver el carrito" +
      "</a>" +

      '<p class="carrito__nota">' +
      "Pago seguro. Los datos de despacho se completan en el siguiente paso." +
      "</p>";
  }

  /* ---------------- Contador ---------------- */

  function contador() {
    document
      .querySelectorAll(
        ".boton-carrito__contador"
      )
      .forEach(function (el) {

        el.textContent =
          estado.count;

        el.classList.toggle(
          "vacio",
          estado.count === 0
        );
      });
  }

  /* ---------------- Animación ---------------- */

  function latir() {
    var b =
      document.querySelector(
        ".boton-carrito__contador"
      );

    if (!b) {
      return;
    }

    b.classList.add("latido");

    setTimeout(function () {
      b.classList.remove("latido");
    }, 600);
  }

  /* ---------------- Abrir / cerrar ---------------- */

  function abrir() {
    var c =
      document.getElementById("carrito");

    if (!c) {
      return;
    }

    c.classList.add("abierto");

    document.body.style.overflow =
      "hidden";
  }

  function cerrar() {
    var c =
      document.getElementById("carrito");

    if (!c) {
      return;
    }

    c.classList.remove("abierto");

    document.body.style.overflow =
      "";
  }

  /* ---------------- Inicio ---------------- */

  function iniciar() {

    document
      .querySelectorAll(
        "[data-abrir-carrito]"
      )
      .forEach(function (b) {

        b.addEventListener(
          "click",
          function (e) {

            e.preventDefault();

            abrir();
          }
        );
      });

    document
      .querySelectorAll(
        "[data-cerrar-carrito]"
      )
      .forEach(function (b) {

        b.addEventListener(
          "click",
          cerrar
        );
      });

    document.addEventListener(
      "keydown",
      function (e) {

        if (e.key === "Escape") {
          cerrar();
        }
      }
    );

    /* ========================================================
       BOTONES "AGREGAR" DE TARJETAS
       ======================================================== */

    document.addEventListener(
      "click",
      function (e) {

        var btn =
          e.target.closest(
            "[data-agregar-variante]"
          );

        if (!btn) {
          return;
        }

        e.preventDefault();

        btn.disabled = true;

        agregar(
          btn.dataset.agregarVariante,
          1
        ).finally(function () {

          btn.disabled = false;

        });
      }
    );

    /* ========================================================
       FORMULARIO PÁGINA DE PRODUCTO
       ======================================================== */

    var form =
      document.querySelector(
        "[data-form-compra]"
      );

    if (form) {

      form.addEventListener(
        "submit",
        function (e) {

          e.preventDefault();

          var input =
            form.querySelector(
              "[data-variante-input]"
            );

          if (!input) {
            return;
          }

          agregar(
            input.value,
            1
          );
        }
      );
    }

    /* ========================================================
       CARGA INICIAL DEL CARRITO
       ======================================================== */

    leer()
      .then(pintar)
      .catch(function () {});
  }

  /* ---------------- API pública NEAT ---------------- */

  window.NEAT_CARRITO = {
    agregar: agregar,
    abrir: abrir,
    cerrar: cerrar,
    clp: clp
  };

  /* ---------------- Arranque ---------------- */

  if (
    document.readyState === "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      iniciar
    );

  } else {

    iniciar();

  }

})();